import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

export const useResetUserProfile = (): VoidFunction => {
  const queryClient = useQueryClient();

  const handleResetUserProfileQueries = useCallback(() => {
    void queryClient.invalidateQueries({
      queryKey: ['userProfile'],
      exact: false,
    });
  }, [queryClient]);

  return handleResetUserProfileQueries;
};
